module.exports = __webpack_public_path__ + "static/img/about-henrik.66b2be5c.jpg";